<template>
  <div class="help-call-container" v-on:click="showCallPage">
    <div class="help-call-text">
      <span>Potrzebujesz pomocy?</span><br>
      Oddzwonimy w 28 sekund!
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showCallPage () {
      window.callpage('api.widget.open')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.help-call-container {
  display: flex;
}
.help-call-text {
  padding: 15px 30px 15px 75px;
  border: 1px solid #41CDA8;
  border-radius: 6px;
  background-color: #FFFFFF;
  box-shadow: 0 0 30px 0 rgba(0,0,0,0.07);
  color: #000000;
  background-image: url(../../assets/img/common/help.png);
  background-position: 30px center;
  background-repeat: no-repeat;
  font-size: 13px;
  line-height: 18px;
}
.help-call-text span {
  font-weight: bold;
}
@media screen and (max-width: 480px) {
  .help-call-container,
  .help-call-text{
    width: 100%;
  }
}
</style>
